import * as FilteringState from '../../../Data/FilteringState'
import {update} from '../../../Data/ObjectHelper'
import * as OrderFilter from './OrderFilter'
import {OrderFilterInput} from './OrderFilterInput'
import * as OrderFilterInputAction from './OrderFilterInputAction'
import * as OrderFilterType from './OrderFilterType'

export type OrderFilteringState =
    FilteringState.M<OrderFilter.OrderFilter, OrderFilterType.OrderFilterType, OrderFilterInput>

export function init(
    activeFilters: OrderFilter.OrderFilter[],
): OrderFilteringState {
    return FilteringState.init(OrderFilter.inactiveFilterTypes, activeFilters)
}

export function setActiveFilters(
    activeFilters: OrderFilter.OrderFilter[],
    state: OrderFilteringState,
): OrderFilteringState {
    return FilteringState.setActiveFilters(
        OrderFilter.inactiveFilterTypes,
        activeFilters,
        state,
    )
}

export function submit(state: OrderFilteringState): OrderFilteringState {
    return FilteringState.submit(
        OrderFilter.fromFilterInput,
        OrderFilter.toFilterType,
        state,
    )
}

export function clearFilters(state: OrderFilteringState): OrderFilteringState {
    return FilteringState.clearFilters(
        OrderFilterType.all(),
        state,
    )
}

export function removeFilter(
    filterType: OrderFilterType.OrderFilterType,
    state: OrderFilteringState
): OrderFilteringState {
    return FilteringState.removeFilter(
        OrderFilter.toFilterType,
        OrderFilterType.sort,
        filterType,
        state,
    )
}

export function reduceFilterInputChanged(
    inputAction: OrderFilterInputAction.M,
    state: OrderFilteringState,
): OrderFilteringState {
    return FilteringState.reduceFilterInputChanged(
        (action, filterInput: OrderFilterInput): OrderFilterInput => {
            switch (action.type) {
                case 'BpsUserChanged':
                    return filterInput.type === 'BpsUserFilterInput' ?
                        update({selectedBpsUser: action.value}, filterInput) :
                        filterInput
                case 'CompanyChanged':
                    return filterInput.type === 'CompanyFilterInput' ?
                        update({selectedCompany: action.value}, filterInput) :
                        filterInput
                case 'CustomerChanged':
                    return filterInput.type === 'CustomerFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'DateFromChanged':
                    return filterInput.type === 'DateFromFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'DateToChanged':
                    return filterInput.type === 'DateToFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'OrderNumberChanged':
                    return filterInput.type === 'OrderNumberFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'OrderPaidChanged':
                    return filterInput.type === 'OrderPaidFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'PriceFromChanged':
                    return filterInput.type === 'PriceFromFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'PriceToChanged':
                    return filterInput.type === 'PriceToFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'ShippingMethodChanged':
                    return filterInput.type === 'ShippingMethodFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
                case 'StatusChanged':
                    return filterInput.type === 'StatusFilterInput' ?
                        update({value: action.value}, filterInput) :
                        filterInput
            }
        },
        inputAction,
        state,
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/OrderFiltering/Model/OrderFilteringState.ts